import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  Image,
  View,
} from "@react-pdf/renderer";
import * as React from "react";
import moment from "moment";
import jsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import { createCanvas, loadImage } from 'canvas';
import { constants } from '../../types/constants';

import { IVente, IPdflink } from "../../types/interfaces";
import { getEncModeRegl } from "../../services/misc";

const generateQrCode = (qrUrl) => {
  try {
    return QRCode.toDataURL(qrUrl); // Generate the QR code as base64 synchronously
  } catch (error) {
    console.error('Error generating QR code:', error);
    return null;
  }
};

Font.register({
  family: 'Open Sans',
  fonts: [
  { src: '/fonts/open-sans-regular.ttf' },
  { src: '/fonts/open-sans-italic.ttf', fontStyle: "italic" },
  { src: '/fonts/open-sans-600italic.ttf', fontWeight: 600, fontStyle: "italic" },
  { src: '/fonts/open-sans-600.ttf', fontWeight: 600 },
  { src: '/fonts/open-sans-300.ttf', fontWeight: 300 }
  ]
});

Font.register({
  family: 'Cairo',
  fonts: [
    { src: '/fonts/Cairo-Regular.ttf' }, // Regular font
    { src: '/fonts/Cairo-Bold.ttf', fontWeight: 700 }, // Bold font
    { src: '/fonts/Cairo-Light.ttf', fontWeight: 300 } // Light font
  ]
});

const MyDocument: any = Document
const MyPage: any = Page

const RecuDocument: React.FC<IPdflink> = ({ data, showPreviewWatermark, title }: IPdflink) => {
  if(!data)
    return (<MyDocument>
      <MyPage size="A4">
        <View>
          <Text>Erreur 968</Text>
        </View>
      </MyPage>
    </MyDocument>)
  
  let canvas = document.createElement("canvas");
  jsBarcode(canvas, `${data.recu_image_counter !== undefined && data.recu_image_counter !== null ? data.recu_image_counter : "-"}_${data.ID_COM || "-"}${data.ID_COM !== data.authUserId ? `_${data.authUserId || "-"}` : ""}`, {format: "CODE128", height: 60, displayValue: true});
  const barcodePNG = canvas.toDataURL("image/png");
  // const qrcodeText = data.webViewLink || "-"
  // const qrCodeDataURL = data.webViewLink && generateQrCode(data.webViewLink);
  const isAssociation = data.isNewAssociation || data.associationId;
  const clients = data.isNewAssociation ? (data.addedContratClients || []) : ((data.clients || data.contrat_clients?.filter(e => !data.associationId || e.ID_ASS == data.associationId).map(e => e.client)).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || []);
  // const clients = data.association /*&& data.enc */? (data.addedContratClients || []) : ((data.clients || data.contrat_clients?.map(e => e.client)).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || []);
  const typeOfBien = data.TYPE ? data.TYPE.toUpperCase().includes("APP") ? constants.APPARTEMENT : data.TYPE.toUpperCase().includes("MAG") ? constants.MAGASIN : data.TYPE.toUpperCase().includes("VILLA") ? constants.VILLA : data.TYPE.toUpperCase().includes("EQUIPEMENT") ? constants.EQUIPEMENT : constants.LOT : "---";
  const allCivilitesAreKnown = clients.filter(e => !e.CIVILITE).length === 0;
  let names = clients.map(e => `${e.NOM} ${e.PRENOM}`);
  let signsLines: string[][] = [];
  let line: string[] = [];
  for(let i in names){
    line.push(names[i])
    if(line.length === 4 || Number(i) === names.length - 1){
      signsLines.push(line);
      line = [];
    }
  }

  const PAGE_SIDE_PADDING = 40;
  
  const styles = StyleSheet.create({
    body: {
      padding: PAGE_SIDE_PADDING,
      paddingBottom: 110
    },
    logoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 12
    },
    middleLogoContainer1: {
      flex: 5
    },
    middleLogoContainer2: {
      display: "flex",
      flexDirection: "column",
      marginLeft: "auto",
      marginRight: "auto",
      width: "80%",
      color: "black",
      fontFamily: 'Open Sans'
    },
    middleLogoText: {
      width: "100%",
      // flex: 1,
      textAlign: "center",
      fontSize: 30,
      fontWeight: 600,
      textTransform: "uppercase"
    },
    logo: {
      height: "auto",
      flex: 1
    },
    normalText: {
      color: "#000000",
      fontSize: 9,
      fontFamily: 'Open Sans',
      width: "100%",
      flexDirection: "row"
    },
    tabbedLine: {
      paddingLeft: 20
    },
    group: {
      marginBottom: 15
    },
    groupTitle: {
      justifyContent: "flex-start",
      marginLeft: 2,
      marginBottom: 5
    },
    mainTitle: {
      color: "#000000",
      fontFamily: 'Open Sans',
      fontWeight: 600,
      fontStyle: "italic",
      width: "100%",
      fontSize: 18,
      justifyContent: "center",
      flexDirection: "row",
      marginBottom: 40
    },
    asteriskText: {
      fontSize: 6
    },
    textMargin: {
      marginBottom: 4
    },
    watermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      transform: "rotate(-60deg)",
      fontSize: 50,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .1
    },
    previewWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      fontSize: 80,
      fontFamily: 'Open Sans',
      // fontStyle: "italic",
      fontWeight: 600,
      color: "#aaaaaa",
      opacity: .4
    },
    borderTest: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "green"
    },
    borderTest2: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "red"
    },
    pageCountContainer: {
      position: "absolute",
      bottom: 2,//14
      left: PAGE_SIDE_PADDING,
      paddingTop: 0,
      paddingBottom: 0,
      width: "100%",
      color: "#333333",
      fontSize: 8
    },
    pageCountText: {
      textAlign: "center",
      marginBottom: 4
    },
    lastElement: {
      marginBottom: 0,
      paddingBottom: 0
    },
    shemsWatermark: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      transform: "rotate(-90deg)",
      opacity: .2,
      overflow: "hidden"
    }
  });
  return (
  <MyDocument creator={"ayoub laazazi"} producer={"producer"} title={title} author={"ayoub laazazi"}>
    <MyPage size="A4" style={{...styles.body, position: "relative"}}>
      <View style={styles.watermark} fixed>
        {/* <Text>{fileObject && fileObject.toUpperCase()}</Text> */}
        <Text>{""}</Text>
      </View>
      {showPreviewWatermark ? <View style={styles.previewWatermark} fixed>
        <Text>Aperçu</Text>
      </View> : null}
      <View style={styles.shemsWatermark} fixed>
        {[...Array(38)].map((_, rowIndex) => (
          <View key={rowIndex} style={{ flexDirection: 'row', justifyContent: 'center' }}>
            {[...Array(20)].map((_, colIndex) => (
              <Text key={colIndex} style={{
                  fontSize: 6,
                  fontFamily: 'Cairo',
                  color: "#aaaaaa",
                  marginHorizontal: 1,
                  marginVertical: 2,
                }}>شمس المدينة •</Text>
            ))}
          </View>
        ))}
      </View>
      <View fixed>
        <View style={styles.logoContainer}>
          <Image src={`/images/icon.png`} style={styles.logo}/>
          <View style={styles.middleLogoContainer1}>
            <View style={styles.middleLogoContainer2}>
              <Text style={styles.middleLogoText}>
                SHEMS AL MADINA
              </Text>
            </View>
          </View>
          <Image src={`/images/icon.png`} style={styles.logo}/>
        </View>
      </View>
      
      <View style={styles.mainTitle} fixed>
        <Text>
          REÇU PAIEMENT N°{data.recu_image_counter !== undefined && data.recu_image_counter !== null ? data.recu_image_counter : "-"}
        </Text>
      </View>
      
      {clients.length === 1 ? <View style={styles.group}>
        <View style={{...styles.normalText}}>
          <Text style={{fontWeight: 600}}>•</Text><Text>&nbsp;Nous attestons la Société</Text><Text style={{fontWeight: 600}}>&nbsp;{data.constantesProjet ? data.constantesProjet.valeur : "---"}</Text><Text>&nbsp;avoir reçu de :</Text>
        </View>
        <View style={{...styles.normalText, ...styles.tabbedLine}}>
          <Text style={{fontWeight: 600}}>-</Text><Text style={{fontWeight: 600}}>{clients[0].CIVILITE && clients[0].CIVILITE !== "Ste" ? (clients[0].CIVILITE + ". ") : ""}</Text><Text>{`${clients[0].NOM} ${clients[0].PRENOM}`}</Text>
        </View>
        <View style={{...styles.normalText, ...styles.tabbedLine}}>
          <Text style={{fontWeight: 600}}>-{clients[0].CIN ? "CIN" : clients[0].PASSPORT ? "Passeport N°" : "-"} :</Text><Text>&nbsp;{clients[0].CIN ? clients[0].CIN : clients[0].PASSPORT ? clients[0].PASSPORT : "-"}</Text>
        </View>
        <View style={{...styles.normalText, ...styles.tabbedLine}}>
          <Text style={{fontWeight: 600}}>-Adresse :</Text><Text>&nbsp;{clients[0].ADRESSE}</Text>
        </View>
        {clients[0].TEL || clients[0].TEL2 ? <View style={{...styles.normalText, ...styles.tabbedLine}}>
          <Text style={{fontWeight: 600}}>-Numéro de téléphone :</Text><Text>&nbsp;{clients[0].TEL && clients[0].TEL2 ? `${clients[0].TEL} / ${clients[0].TEL2}` : clients[0].TEL2 ? clients[0].TEL2 : clients[0].TEL}</Text>
        </View> : null}
      </View> : <View style={styles.group}>
        <View style={{...styles.normalText, ...styles.groupTitle}}>
          <Text>Nous attestons la Société</Text><Text style={{fontWeight: 600}}>&nbsp;{data.constantesProjet ? data.constantesProjet.valeur : "---"}</Text><Text>&nbsp;avoir reçu de :</Text>
        </View>
        {clients.map((e, key) => <View style={{...styles.normalText, ...styles.tabbedLine}} key={key}>
          <Text>
          <Text style={{fontWeight: 600}}>-</Text>{allCivilitesAreKnown ? <Text style={{fontWeight: 600}}>{e.CIVILITE && e.CIVILITE !== "Ste" ? (e.CIVILITE + ". ") : ""}</Text> : null}<Text>&nbsp;{`${e.NOM} ${e.PRENOM}`}</Text>
          <Text style={{fontWeight: 600}}>, {e.CIN ? "CIN" : e.PASSPORT ? "Passeport N°" : "-"} :</Text><Text>&nbsp;{e.CIN ? e.CIN : e.PASSPORT ? e.PASSPORT : "-"}</Text>
          <Text style={{fontWeight: 600}}>, Adresse :</Text><Text>&nbsp;{e.ADRESSE}</Text>
          {e.TEL || e.TEL2 ? <Text style={{fontWeight: 600}}>, N° de Téléphone :</Text> : null}
          {e.TEL || e.TEL2 ? <Text>&nbsp;{e.TEL && e.TEL2 ? `${e.TEL} / ${e.TEL2}` : e.TEL2 ? e.TEL2 : e.TEL}</Text> : null}
          </Text>
        </View>)}
      </View>}
      
      <View style={styles.group}>
        <View style={{...styles.normalText}}>
          <Text style={{fontWeight: 600}}>• Une avance {data.enc ? "supplémentaire " : ""}de :</Text><Text>&nbsp;{((!data.enc && !data.isNewAssociation && (data.contrat_encaissements || data.encaissements)) || ((data.enc || data.isNewAssociation) && data.addedContratEnc)) ? ((data.enc || data.isNewAssociation ? data.addedContratEnc : (data.contrat_encaissements || data.encaissements)) || 0).reduce((prev, b) => prev + (Number(b.PART) || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs détaillée comme suit:</Text>
        </View>
        {/* <Text style={{...styles.normalText, ...styles.tabbedLine}}>
          - 20,000.00 Dhs par CHEQUE N° 188832922 tiré par ATTIJARIWAFA BANK le 29/12/2020
        </Text>
        <Text style={{...styles.normalText, ...styles.tabbedLine}}>
          - 80,000.00 Dhs par CHEQUE N° 190179905 tiré par ATTIJARIWAFA BANK le 29/12/2020
        </Text> */}
        {data.contrat_encaissements && !data.enc && !data.isNewAssociation ? (data.contrat_encaissements || []).filter(e => !data.associationId || e.ID_ASS == data.associationId).map((e, key) => {return <Text style={{...styles.normalText, ...styles.tabbedLine}} key={key}>
          - {(Number(e.PART) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs {(Number(e.encaissement?.MONTANT || 0) || 0) != (Number(e.PART) || 0) ? ("(de " + (Number(e.encaissement?.MONTANT || 0) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " Dhs) ") : ""}par {getEncModeRegl(e.encaissement?.MODE_REGL)} N° {e.encaissement?.REF_REGLEMENT || "-"} {(e.encaissement?.MODE_REGL) === "CHEQUE" ? "tiré sur" : "sur"} {e.encaissement ? e.encaissement.bank ? e.encaissement.bank.fullname : e.encaissement.BANQUE : "-"}
           {/* le {e.encaissement?.DATE_REGLEMENT ? moment(e.encaissement.DATE_REGLEMENT).format('DD/MM/YYYY') : "-"} */}
        </Text>}) : ((data.enc || data.isNewAssociation ? data.addedContratEnc : data.encaissements) || []).map((e, key) => {return <Text style={{...styles.normalText, ...styles.tabbedLine}} key={key}>
          - {(Number(e.PART) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs {(Number(e.MONTANT) || 0) != (Number(e.PART) || 0) ? ("(de " + (Number(e.MONTANT) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + " Dhs) ") : ""}par {getEncModeRegl(e.MODE_REGL)} N° {e.REF_REGLEMENT || "-"} {e.MODE_REGL === constants.MODE_REGL_CHEQUE ? "tiré sur" : "sur"} {e.bank ? e.bank.fullname : e.BANQUE}
           {/* le {e.DATE_REGLEMENT ? moment(e.DATE_REGLEMENT).format('DD/MM/YYYY') : "-"} */}
        </Text>})}
      </View>
      
      <View style={styles.group}>
        <Text style={{...styles.normalText, fontWeight: 600}}>
          • Pour l'intention de {data.enc ? " faire une avance supplémentaire concernant" : "réserver ultérieurement"}{isAssociation ? " une part de" : ""} :
        </Text>
        <Text style={{...styles.normalText, ...styles.tabbedLine}}>
          -N° Dossier : {data.NUM_DOSS}
        </Text>
        <Text style={{...styles.normalText, ...styles.tabbedLine}}>
          -Type : {typeOfBien === constants.APPARTEMENT ? "Appartement" : typeOfBien === constants.MAGASIN ? "Magasin" : "Lot"}
        </Text>
        <Text style={{...styles.normalText, ...styles.tabbedLine}}>
          -Désignation : {`${data.TYPE} N°${data.N} tranche ${data.TRANCHE}`} {typeOfBien === constants.APPARTEMENT || typeOfBien === constants.MAGASIN ? ` Immeuble ${data.IMMEUBLE}` : "" }
        </Text>
        <Text style={{...styles.normalText, ...styles.tabbedLine}}>
          -Projet : {data.constantesProjet ? data.constantesProjet.valeur2 : "---"}
          {/* -Projet Shems Al Madina Tit Mellil 5 (TODO) */}
        </Text>
        {typeOfBien === constants.APPARTEMENT ? <Text style={{...styles.normalText, ...styles.tabbedLine}}>
          -Étage : {data.ETAGE || "-"}
        </Text> : null}
        {!data.enc ? <View>
          {typeOfBien !== constants.APPARTEMENT ? <Text style={{...styles.normalText, ...styles.tabbedLine}}>
            -Surface : {data.SUPERFICIE ? (data.SUPERFICIE + "m²") : "-"}
          </Text> : null}
          {typeOfBien !== constants.APPARTEMENT ? <Text style={{...styles.normalText, ...styles.tabbedLine}}>
            -Prix m²: {data.PRIX_M || data.PRIX_M === 0 ? ((Number(data.PRIX_M) || 0) - (data.REMISE_VALIDEE === -1 ? (data.SUPERFICIE ? Number(((Number(data.REMISE) || 0) / data.SUPERFICIE).toFixed(2)) : 0) : 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs{data.REMISE && data.REMISE_VALIDEE !== 0 && !isAssociation ? ` (dont une remise de ${data.REMISE && data.SUPERFICIE ? (Number(data.REMISE) / Number(data.SUPERFICIE)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs le M²${data.REMISE_VALIDEE === -1 ? " pas encore validée par l'administration" : ""})` : ""}
            {/* -Prix m²: {(data.PRIX_M_CLIENT || data.PRIX_M_CLIENT === 0 || data.PRIX_NET || data.PRIX_NET === 0) && data.SUPERFICIE ? ((Number(data.PRIX_M_CLIENT || data.PRIX_NET) - (data.REMISE_VALIDEE === 0 ? 0 : (Number(data.REMISE) || 0))) / Number(data.SUPERFICIE)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs{data.REMISE && data.REMISE_VALIDEE !== 0 && !data.association ? ` (dont une remise de ${data.REMISE && data.SUPERFICIE ? (Number(data.REMISE) / Number(data.SUPERFICIE)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs le M²${data.REMISE_VALIDEE === -1 ? " pas encore validée par l'administration" : ""})` : ""} */}
          </Text> : null}
          <Text style={{...styles.normalText, ...styles.tabbedLine}}>
            -Prix: {data.PRIX_NET || data.PRIX_NET === 0 ? ((Number(data.PRIX_NET) || 0) - (data.REMISE_VALIDEE === -1 ? (Number(data.REMISE) || 0) : 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs{data.REMISE && data.REMISE_VALIDEE !== 0 && !isAssociation ? ` (dont une remise de ${data.REMISE ? Number(data.REMISE).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs${data.REMISE_VALIDEE === -1 ? " pas encore validée par l'administration" : ""})` : ""}
            {/* -Prix: {(data.PRIX_M_CLIENT || data.PRIX_M_CLIENT === 0 || data.PRIX_NET || data.PRIX_NET === 0) ? (Number(data.PRIX_M_CLIENT || data.PRIX_NET) - (data.REMISE_VALIDEE === 0 ? 0 : (Number(data.REMISE) || 0))).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs{data.REMISE && data.REMISE_VALIDEE !== 0 && !data.association ? ` (dont une remise de ${data.REMISE ? Number(data.REMISE).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') : "-"} Dhs${data.REMISE_VALIDEE === -1 ? " pas encore validée par l'administration" : ""})` : ""} */}
          </Text>
        </View> : null}
      </View>

      {data.REMISE && data.REMISE_VALIDEE === -1 && !isAssociation/* remove the 3 !data.association later fch tzid remise l asso itself.. */ ? <View style={styles.group}>
        <Text style={styles.normalText}>
          Une proposition de remise de {Number(data.REMISE).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs, cette remise n'est pas encore validée par la société, en cas de non validation de cette remise, le prix de vente sera {(Number(data.PRIX_NET) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs.
          {/* Une proposition de remise de {Number(data.REMISE).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs, cette remise n'est pas encore validée par la société, en cas de non validation de cette remise, le prix de vente sera {((Number(data.PRIX_NET) || 0) - (Number(data.REMISE) || 0)).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ')} Dhs. */}
        </Text>
      </View> : null}

      <View style={styles.group}>
        {typeOfBien !== constants.APPARTEMENT ? <View>
          <Text style={styles.normalText}>
            En cas de différence entre la surface commerciale et la surface cadastrale, le prix définitif de vente sera calculé sur la base de la surface cadastrale.
          </Text>
          <Text style={styles.normalText}>
            {typeOfBien === constants.MAGASIN ? "La réservation du magasin ne sera faite qu'après le paiement total du prix du magasin."
            : typeOfBien === constants.APPARTEMENT ? "La réservation de l'appartement ne sera faite qu’après le paiement total du prix de l'appartement et de la signature du contrat de réservation par la société et les futurs réservataires."
            : "La réservation du lot ne sera faite qu’après le paiement total du prix du lot et de la signature du contrat de réservation par la société et les futurs réservataires."}
          </Text>
        </View> : null}
        {!data.enc ? <Text style={styles.normalText}>
          Ce document est un reçu de paiement, La société se réserve le droit de l'annuler par simple restitution du montant reçu.
        </Text> : null}
        <Text style={styles.normalText}>
          Cette transaction sera considérée comme nulle et caduque dans les cas suivants :
        </Text>
        <Text style={styles.normalText}>
          -Retour d’un chèque impayé.
        </Text>
        <Text style={styles.normalText}>
          -Non réception d’un virement ou versement dans un délai de 7 jours par la société bénéficiaire.
        </Text>
      </View>

      <View style={{...styles.normalText, ...styles.groupTitle, fontWeight: 600, justifyContent: "flex-end"}}>
        <Text>
          Le {data.specificDate ? moment(data.specificDate).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY')}
        </Text>
      </View>

      <View style={{...styles.normalText, ...styles.groupTitle, fontWeight: 600, textDecoration: "underline", marginBottom: 25}}>
        <Text>
          Société {data.constantesProjet ? data.constantesProjet.valeur : "---"}:
        </Text>
      </View>

      <View style={{}}>
        <Text style={{...styles.normalText}}>
          lu et approuvé:
        </Text>
      </View>

      <View style={{...styles.normalText, ...styles.groupTitle, ...styles.lastElement, flexDirection: "column", fontWeight: 600, textDecoration: "underline"}}>
        {signsLines.map((e, keyE, arrE) => <View style={{width: "100%", flexDirection: "row", marginBottom: 50, ...(keyE === arrE.length - 1 ? styles.lastElement : {})}} key={keyE}>
          {e.map((t, keyT) => <Text style={{width: "25%", textAlign: "center", ...(keyE === arrE.length - 1 ? styles.lastElement : {})}} key={keyT}>
            {t}
          </Text>)}
        </View>)}
      </View>

      

      <View style={styles.pageCountContainer} fixed>
        <View style={{flexDirection: "row", justifyContent: "flex-end"}}>
          {/* <Image src={data.chartUrl} style={{width: 90, height: "auto"}} /> */}
          {/* <Image src={barcodePNG} style={{width: 90, height: "auto"}} /> */}
        </View>
        <Text style={styles.pageCountText} render={({ pageNumber, totalPages }) => totalPages > 1 && `${pageNumber} / ${totalPages}`} fixed />
        <View style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "flex-end"}}>
          <View style={{display: "flex", flexDirection: "column", flex: 1}}>
            <View style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", fontSize: 11, fontFamily: 'Cairo'}}>
              {/* <Text>للتحقق من صحة معلوماتك</Text> */}
              <Text>بكاميرا الهاتف للتحقق من صحة إيصالك</Text>
              <Text>&nbsp;QR&nbsp;</Text>
              <Text>امسح رمز</Text>
            </View>
            <View style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", fontSize: 11}}>
              <Text>Scannez ce code QR pour vérifier l'authenticité de votre reçu</Text>
            </View>
          </View>
          <Image src="/images/arrow-down.png" style={{width: 20, height: "auto"}} />
        </View>
        <View style={{marginBottom: 30, display: "flex", flexDirection: "row"}}>
          <View style={{flex: 1, justifyContent: "flex-end", alignItems: "center"}}>
            <View style={{...styles.asteriskText, paddingRight: 10, paddingBottom: 10}}>
              <Text>
                - Ce reçu engage définitivement le client quant à l'achat ferme et définitif {typeOfBien === constants.MAGASIN ? "du magasin" : typeOfBien === constants.APPARTEMENT ? "de l'appartement" : "du lot"} objet de ce reçu.
              </Text>
              <Text>
                Dès l'obtention des titres fonciers parcellaires, la société {data.constantesProjet ? data.constantesProjet.valeur : "---"} adressera au client une lettre recommandée avec accusé de réception à l'adresse indiquée ci-dessus, l'invitant à régler le solde définitif du prix de vente et à signer le contrat définitif de vente auprès d'un notaire désigné par la société {data.constantesProjet ? data.constantesProjet.valeur : "---"} dans un délai n’excédant pas 15 jours à partir de la date de réception de cette lettre.
              </Text>
              <Text>
                Le non-respect de ce délai entraine l'annulation du présent reçu et donne droit à la société à une indemnité équivalente à {isAssociation ? "5" : "10"}% du prix total de vente.
              </Text>
              {typeOfBien === constants.APPARTEMENT ? <View>
                <Text>
                  Le client atteste qu’il reconnait et accepte toutes les conditions d’éligibilité au logement social au Maroc tel qu’énuméré dans la loi en vigueur :
                </Text>
                <Text>
                  -Qu’il n’a pas  d’autre propriété.
                </Text>
                <Text>
                  -Que cet appartement sera destiné à son habitation principale pendant une durée de 4 ans.
                </Text>
                <Text>
                  -Qu’il est marocain et majeur.
                </Text>
                <Text>
                  -Que la désignation de ce bien se fera au moment de la signature du contrat définitif de vente, lequel se fera chez un notaire désigné par la société {data.constantesProjet ? data.constantesProjet.valeur : "---"}.
                </Text>
              </View> : null}
              {/* <View style={{marginTop: 10, fontSize: 8}}><Text>Shems Almadina, Route nationale N° 9, Ech-Chellalate, Mohammedia</Text></View> */}
            </View>
          </View>
          {!!data?.qrCodeDataURL && <Image src={data.qrCodeDataURL} style={{width: 90, height: "auto"}} />}
        </View>
      </View>
    </MyPage>
  </MyDocument>
  )
};

export default RecuDocument;
